import { FC } from 'react';

import LegendRightItem from '@/apps/mwd-v2/components/Legends/Right/LegendRightItem';
import useProgressiveWerklijnen from '@/apps/mwd-v2/hooks/useProgressiveWerklijnen';
import { legendMarginBottomPx, legendRightWidthPx } from '@/apps/mwd-v2/utils/timescale';

import styles from './LegendRight.module.css';

const MwdLegendRightContainer: FC = () => {
  const { mwd, werklijnen } = useProgressiveWerklijnen();
  return (
    <div style={{ height: `${mwd.height + legendMarginBottomPx}px` }} className={styles.legendRightContainerStyle}>
      <svg width={legendRightWidthPx} height={mwd.height} viewBox={`0 0 ${legendRightWidthPx} ${mwd.height}`}>
        {werklijnen.map((werklijn) => (
          <LegendRightItem
            key={werklijn.werklijnId}
            y={werklijn.y}
            legendRight={werklijn.right}
            height={werklijn.height}
          />
        ))}
      </svg>
    </div>
  );
};
export default MwdLegendRightContainer;
